export const GRID_CONFIG = {
    columnHidingEnabled: false,
    columnAutoWidth: false,
    rowAlternationEnabled: true,
    searchPanel: {
        visible: true,
        placeholder: "Search..."
    },
    filterRow: {
        visible: false,
        applyFilter: "auto"
    },
    headerFilter: {
        visible: false
    }
}